import { NeutralColors,Text } from "@fluentui/react"

interface HeaderTableProps {
    title: string
    subTitle?: string
}
export const HeaderTablaDetail=(props:HeaderTableProps)=>{
       return(
            <div style={{display:'flex',flexDirection:'column',margin: "0px 20px",paddingBottom:'20px',paddingTop:'20px'}}>
            <Text variant="xLarge" style={{fontWeight:'bold'}}>{props.title}</Text>
            <Text variant="medium" style={{color: NeutralColors.gray130}}>{props.subTitle} </Text>
            </div>
       )
}